import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

export const getSMDSearchlist = (searchItem) => {
  let url = `${API.SMDSearch}?companyname=${searchItem.companyname}&PageNumber=${searchItem.pagenumber}&PageSize=${searchItem.pagesize}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetSMDSearchSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetSMDSearchFailure",
          error: "ERROR"
        })
      })
  }
}

export const deleteSMD = (id) => {
  let url = `${API.SMDDelete}${id}`;
  return dispatch => {
    axios.delete(url)
      .then((response) => {
        toast.success('Deleted Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        dispatch({
          type: "SMDDeleteSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "SMDDeleteFailure",
          error: "ERROR"
        })
      })
  }
}